import { LoadingContainer } from 'components/loadingContainer'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import { UserRole } from 'types/Organization'

export const ProtectedRouteOASA = () => {
    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()

    return (
        <LoadingContainer isLoading={isLoadingCurrentAccount} error={errorCurrentAccount}>
            {currentAccount && (currentAccount.role === UserRole.superAdmin || currentAccount.role === UserRole.orgAdmin) ? (
                <Outlet />
            ) : (
                <Navigate to="/login" />
            )}
        </LoadingContainer>
    )
}
